import PropTypes from 'prop-types';
import { buttonsConfig } from '../../enums/buttonsTypes';
export default function ButtonCustom({ 
    type, 
    icon = true, 
    label = true,
    iconPosition = 'left',
    classCustom = '', 
    children,
    onClick, 
    buttonType,
    ...rest 
    }) {
    const config = buttonsConfig[type];

    return (
        <button
            type={buttonType !== null && buttonType !== undefined ? buttonType : 'button'}
            className={`btn ${config.variant} ${classCustom}`}
            onClick={onClick}
            {...rest}
        >
            {iconPosition === 'left' && icon && <i className={`${config.icon}`}></i>}
            {label && <span className="font-size-14 fw-bold text-nowrap">{config.label}</span>}
            {iconPosition === 'right' && icon && <i className={config.icon}></i>}
            {children}
        </button>
    )
}

ButtonCustom.propTypes = {
    type: PropTypes.string.isRequired,
    icon: PropTypes.bool,
    label: PropTypes.bool,
    iconPosition: PropTypes.oneOf(['left', 'right']),
    classCustom: PropTypes.string,
    children: PropTypes.node,
    onClick: PropTypes.func,
};
